import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { DELETE_CLIENT } from "../../store/drip-campaign-actions";
import DripCampaignClientsTable from "./drip-campaign-clients-table.vue";
import { GenericModal } from "@Shared/components/modals";
import RefreshButton from "@Shared/components/buttons/refresh-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignClientsModal",
  components: {
    GenericModal,
    DripCampaignClientsTable,
    RefreshButton
  },
  props: {
    campaignId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      refreshing: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DripCampaignStore", [DELETE_CLIENT])), {}, {
    showModal() {
      this.$refs.modal.show();
    },
    hideModal() {
      this.$refs.modal.hide();
    },
    async handleDeleteClient(clientProfileId) {
      await this.DELETE_CLIENT({
        campaignId: this.campaignId,
        clientProfileId
      });
      this.$emit("deleted");
      this.handleRefresh();
    },
    handleBulkDeleteClients() {
      this.$emit("deleted");
    },
    handleRefresh() {
      this.$refs.upcomingTable.refreshData();
    }
  })
});